<template>
  <v-card>
    <v-card-title primary-title>
      <v-container fluid class="panel">
        <v-layout row wrap>
          <v-flex xs12>
            <v-layout column class="panel-heading">
              <v-flex xs12>
                <h2 class="panel-title">
                  <b>
                    <span v-html="$t('private_dash_table_parkings_title')"></span>
                  </b>
                </h2>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 hidden-sm-and-down>
            <v-data-table :headers="headers" :items="items" rowsPerPageText="" :custom-sort="customTableSort" :rows-per-page-items="rowsPerPageItems">
              <template slot="items" slot-scope="props">
                <td>
                  <v-chip :color="props.item.statusClass" disabled outline>{{ $t(props.item.statusText) }}</v-chip>
                </td>
                <td>
                  <router-link :to="{ name: 'ParkingHome', params: { id: props.item.id } }">{{ props.item.name }}</router-link>
                </td>
                <td class="text-xs-right">{{ props.item.subscriptions }}</td>
                <td class="text-xs-right">{{ props.item.bookings }}</td>
                <td class="text-xs-right">{{ props.item.incomes }}</td>
              </template>
              <template slot="no-data">
                <v-alert :value="true" outline color="info" v-html="$t('private_dash_table_earnings_nodata')"> </v-alert>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex sm12 v-if="$vuetify.breakpoint.smAndDown">
            <v-data-table :headers="headersSm" :items="items" :custom-sort="customTableSort" expand :rows-per-page-items="rowsPerPageItems" item-key="name">
              <template slot="items" slot-scope="props">
                <tr @click="props.expanded = !props.expanded">
                  <td>{{ props.item.name }}</td>
                  <td class="text-xs-right">{{ props.item.incomes }}</td>
                </tr>
              </template>
              <template slot="no-data">
                <v-alert :value="true" outline color="info" v-html="$t('private_dash_table_earnings_nodata')"> </v-alert>
              </template>
              <template slot="expand" slot-scope="props">
                <v-flex style="padding-left: 20px">
                  <v-card flat>
                    <v-list dense>
                      <v-list-tile>
                        <v-list-tile-content>{{ $t('private_dash_table_parkings_column_status') }}</v-list-tile-content>
                        <v-list-tile-content class="align-end">
                          <v-chip :color="props.item.statusClass" disabled outline>{{ $t(props.item.statusText) }}</v-chip>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>{{ $t('private_dash_table_parkings_column_subscriptions') }}</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ props.item.subscriptions }}</v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>{{ $t('private_dash_table_parkings_column_bookings') }}</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ props.item.bookings }}</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-title>
  </v-card>
</template>

<script>
import FromDateSelector from '@/components/commons/FromToDateSelector.vue';
import statisticService from '@/services/statisticService';
import moment from 'moment';
import _ from 'lodash';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'briefing-parking-list',
  components: {
    [FromDateSelector.name]: FromDateSelector
  },
  props: ['parkingId'],
  data() {
    return {
      rowsPerPageItems: [25, 50, 100, { text: this.$i18n.t('row_pagination_all'), value: -1 }],
      dates: [],
      isEmpty: true,
      headers: [
        {
          i18nText: 'private_dash_table_parkings_column_status',
          text: this.$i18n.t('private_dash_table_parkings_column_status'),
          align: 'center',
          value: 'statusText'
        },
        {
          i18nText: 'private_dash_table_parkings_column_name',
          text: this.$i18n.t('private_dash_table_parkings_column_name'),
          align: 'left',
          value: 'name'
        },
        {
          i18nText: 'private_dash_table_parkings_column_subscriptions',
          text: this.$i18n.t('private_dash_table_parkings_column_subscriptions'),
          align: 'right',
          value: 'subscriptions'
        },
        {
          i18nText: 'private_dash_table_parkings_column_bookings',
          text: this.$i18n.t('private_dash_table_parkings_column_bookings'),
          align: 'right',
          value: 'bookings'
        },
        {
          i18nText: 'private_dash_table_parkings_column_incomes',
          text: this.$i18n.t('private_dash_table_parkings_column_incomes'),
          align: 'right',
          value: 'incomes'
        }
      ],
      headersSm: [
        {
          i18nText: 'private_dash_table_parkings_column_name',
          text: this.$i18n.t('private_dash_table_parkings_column_name'),
          align: 'left',
          value: 'name'
        },
        {
          i18nText: 'private_dash_table_parkings_column_incomes',
          text: this.$i18n.t('private_dash_table_parkings_column_incomes'),
          align: 'right',
          value: 'incomes'
        }
      ],
      items: [
        {
          statusClass: 'yellow',
          statusText: '-',
          name: '-',
          subscriptions: '-',
          bookings: '-',
          incomes: '-',
          id: 0
        }
      ]
    };
  },
  created() {
    EventBus.$on(keys.eventOnLanguageChanged, this.updateRankings);
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.updateRankings);
  },
  methods: {
    customTableSort(items, index, isDescending) {
      if (index === null) {
        return items;
      }

      let orderByStrategy = 'asc';
      if (isDescending) {
        orderByStrategy = 'desc';
      }

      let column = index;
      if (index === 'incomes') {
        column = 'incomeNumber';
      }

      return _.orderBy(items, [column], orderByStrategy);
    },
    sortIncomes(row1, row2) {
      let a = parseFloat(Number(row1.incomes.replace(/[^0-9-]+/g, '')));
      let b = parseFloat(Number(row2.incomes.replace(/[^0-9-]+/g, '')));

      return a < b ? -1 : a > b ? 1 : 0;
    },
    async updateRankings(dates) {
      if (typeof dates === 'undefined') {
        if (this.dates.length === 0) {
          return;
        }
      } else {
        this.dates = _.clone(dates);
      }

      let params = {
        start: moment(this.dates[0]).format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        end: moment(this.dates[1]).format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      };

      if (typeof this.parkingId !== 'undefined') {
        params.parking = this.parkingId;
      }

      _.each(this.headers, itHeader => {
        itHeader.text = this.$i18n.t(itHeader.i18nText);
      });

      _.each(this.headersSm, itHeader => {
        itHeader.text = this.$i18n.t(itHeader.i18nText);
      });

      this.rowsPerPageItems = [25, 50, 100, { text: this.$i18n.t('row_pagination_all'), value: -1 }];

      await statisticService.ranking(params, this.rankingSuccessCallback, this.rankingErrorCallback);
    },
    rankingSuccessCallback(data) {
      if (typeof data.chartData === 'undefined' || data.chartData.length <= 0) {
        this.isEmpty = true;
        return;
      }
      this.isEmpty = false;
      this.data = [];
      this.items = [];

      _.each(data.chartData, itParking => {
        let statusClass = '';
        let statusText = '';
        switch (itParking.status) {
          case 'ACTIVED':
            statusClass = 'green';
            statusText = 'private_parking_status_active';
            break;
          case 'COMING_SOON':
          case 'BUILDING':
          case 'TRAINING':
            statusClass = 'yellow';
            statusText = 'private_parking_status_comingsoon';
            break;
          case 'MAINTENANCE':
            statusClass = 'yellow';
            statusText = 'private_parking_status_maintenance';
            break;
          case 'OFFLINE':
            statusClass = 'red';
            statusText = 'private_parking_status_offline';
            break;
          case 'REMOVED':
            statusClass = 'red';
            statusText = 'private_parking_status_removed';
            break;
          case 'BLOCKED':
            statusClass = 'red';
            statusText = 'private_parking_status_blocked';
            break;
          default:
            statusClass = 'green';
            statusText = 'private_parking_status_active';
            break;
        }
        this.items.push({
          statusClass: statusClass,
          statusText: statusText,
          name: itParking.name,
          id: itParking.id,
          subscriptions: itParking.subscriptions,
          bookings: itParking.bookings,
          incomes: itParking.incomes,
          incomeNumber: parseFloat(Number(itParking.incomes.replace(/[^0-9-]+/g, '')))
        });
      });
    },
    rankingErrorCallback(data) {}
  }
};
</script>

<style lang="scss" scoped>
.panel .panel-heading .panel-title {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 0;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/BriefingParkingList.vue